import axios from 'axios';
import { format, parseISO } from 'date-fns';

import { apiConfig } from '@constants';
import { helpers } from '@helpers';

import { getSegmentHeaders } from './getSegmentHeaders';
import { getTagFromStatus } from './getTagFromStatus';

import { getDeviceKey } from '../../helpers/KeyUtils';

export const SegmentIdentifyUser = async (userSettings, isTVEUser) => {
  const {
    firstName,
    lastName,
    email,
    dspCustomerId,
    trialStart,
    substart,
    subscriptionStatus,
    scheduledcancellationat,
    pricePlan,
  } = userSettings;

  // Pull from config
  const SEGMENT_ID = apiConfig.SEGMENT_ID;

  const tag = getTagFromStatus(subscriptionStatus);
  const deviceId = getDeviceKey();

  // Empty string for TVE users, interval units: monthly, annual
  const subscriptiontype = isTVEUser ? '' : helpers.getSubscriptionType(pricePlan);

  // Change from TWC to group Active and Trialing Users together in one campaign
  const newSubscriptionStatus = subscriptionStatus === 'trialing' ? 'active' : subscriptionStatus;

  const substartFormatted = substart ? format(parseISO(substart), 'MM-dd-yyyy') : '';

  const scheduledcancellationatFormatted = scheduledcancellationat
    ? format(parseISO(scheduledcancellationat), 'MM-dd-yyyy')
    : '';

  const userData = {
    userId: isTVEUser ? deviceId : email,
    traits: {
      dotstudio_id: isTVEUser ? '' : dspCustomerId,
      email: isTVEUser ? '' : email,
      subscriptionstate: isTVEUser ? 'cable' : subscriptionStatus,
      firstName: isTVEUser ? '' : firstName,
      lastName: isTVEUser ? '' : lastName,
      tags: [tag],
      subscriptiontype,
      scheduledcancellationat: scheduledcancellationatFormatted,
      substart: substartFormatted,
    },
  };

  if (isTVEUser) {
    userData.traits.device_id = deviceId;
  } else {
    const parsedISODate = parseISO(trialStart);

    if (!isNaN(parsedISODate)) {
      const formattedTrialStart = format(parsedISODate, 'MM-dd-yyyy');

      userData.traits.trialstart = formattedTrialStart;
    }

    // lists data only for non TVE users
    userData.lists = [
      {
        id: SEGMENT_ID,
        status: newSubscriptionStatus,
      },
    ];
  }

  const headers = getSegmentHeaders();

  console.log('segment id:', userData);

  if (headers) {
    return axios
      .post(apiConfig.SEGMENT_IDENTIFY_URL, userData, { headers })
      .then(() => {
        console.log('Identified user!');
      })
      .catch(error => {
        if (error.response) {
          error.response.data.success === false;
        }
        console.error('Failed to identify user', error);
      });
  }
};
